export enum DirectoryTarget {
  default,
  filter,
  associateFilter,
}
